// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.w2Ok_QPiPTxPuy {
  flex-shrink: 0;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `w2Ok_QPiPTxPuy`
};
export default ___CSS_LOADER_EXPORT___;
